import acaiCopo from "../assets/images/acai-copo.jpg";
import atendimento from "../assets/images/atendimento.jpg";
import biscoitos from "../assets/images/biscoitos.jpg";
import caldoCanaProducao from "../assets/images/caldo-cana-producao.jpg";
import caldoCanaVideoPoster from "../assets/images/caldo-cana-video-poster.jpg";
import coxinhas from "../assets/images/coxinhas.jpg";
import espacoCafe from "../assets/images/espaco-cafe.jpg";
import paoDeQueijo from "../assets/images/pao-de-queijo.jpg";
import pastelFrito from "../assets/images/pastel-frito.jpg";
import pastelariaVitrine from "../assets/images/pastelaria-vitrine.jpg";
import salgadosMesa from "../assets/images/salgados-mesa.jpg";
import tarteBalcao from "../assets/images/tarte-balcao.jpg";
import caldoCanaVideo from "../assets/videos/caldo-cana.mp4";
import type { AssetSlotId } from "../types/content";

export const imageAssets: Partial<Record<AssetSlotId, string>> = {
  HERO_FACHADA_OU_COMPOSICAO: pastelFrito,
  ESPACO_INTERIOR: espacoCafe,
  EQUIPA_OU_ATENDIMENTO: atendimento,
  BALCAO: tarteBalcao,
  PRODUTO_PASTEIS: pastelFrito,
  PRODUTO_COXINHAS: coxinhas,
  PRODUTO_SALGADOS: salgadosMesa,
  PRODUTO_ACAI: acaiCopo,
  PRODUTO_CALDO_DE_CANA: caldoCanaProducao,
  ENCOMENDAS_FESTAS: salgadosMesa,
  GALERIA_01: espacoCafe,
  GALERIA_02: tarteBalcao,
  GALERIA_03: pastelariaVitrine,
  GALERIA_04: salgadosMesa,
  GALERIA_05: acaiCopo,
  GALERIA_06: atendimento,
  GALERIA_07: biscoitos,
  GALERIA_08: paoDeQueijo,
};

export const imagePositions: Partial<Record<AssetSlotId, string>> = {
  PRODUTO_COXINHAS: "center 72%",
  GALERIA_06: "center 35%",
};

export const mediaAssets = {
  caldoCanaVideo,
  caldoCanaVideoPoster,
};
